// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_container__2-yhh","curt":"modal_curt__e1lwm"};